import React, { useState, useEffect } from "react";
import Loader from "react-spinner-loader";
import Table, { TableRow } from "../../component/table";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import RowsPerPageSelector from "../../component/RowsPerPageSelector";
import PageSelector from "../../component/PageSelector";
import { getOldRequestData } from "../../redux/actions/request";

function OldRequestTable() {
  const dispatch = useDispatch();
  const { oldRequestData } = useSelector((state) => state.request);
  const { row_count } = useSelector((state) => state.auth);

  const [page, setPage] = useState(1);
  const [sort, setSort] = useState();
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [loader, setLoader] = useState(false);

  const getOldRequest = async () => {
    setLoader(true);
    const request = {
      onSuccess: () => {
        setLoader(false);
      },
      onError: () => {
        setLoader(false);
      },
    };
    dispatch(getOldRequestData(request, page, sortField, sortOrder, row_count));
  };

  useEffect(() => {
    getOldRequest();
  }, [page, sortField, sortOrder, row_count]);

  /*--------- Sorting New Request ------------ */
  useEffect(() => {
    if (sort) {
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  return (
    <div className="space-y-1">
      <Table
        heads={[
          { headName: "From User", isSort: true, value: "user" },
          { headName: "Request Type", isSort: true, value: "type" },
          { headName: "To Do", isSort: true, value: "activity" },
          {
            headName: "Booking ID",
            isSort: true,
            value: "activity_assignment",
          },
          {
            headName: "Remarks",
            isSort: true,
            value: "description",
          },
          {
            headName: "Requested On",
            isSort: true,
            value: "createdAt",
          },
          { headName: "Status", isSort: true, value: "status" },
        ]}
        tClass="table-fixed w-full border-separate border-spacing-y-2"
        hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50]"
        bClass="text-sm"
        thClass={`px-2 py-3 whitespace-nowrap first:text-left text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
        setSort={setSort}
        sort={sort}
      >
        {loader ? (
          <tr className="px-2 py-3 whitespace-nowrap">
            <td colSpan={6}>
              <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                <Loader show={loader} />
              </div>
            </td>
          </tr>
        ) : oldRequestData?.data?.length > 0 ? (
          oldRequestData?.data.map((item, index) => {
            const {
              type,
              user,
              activity,
              activity_assignment,
              description,
              status,
            } = item;
            const name = user?.name;
            const todo = activity?.name;
            const bookingId = activity_assignment?.job_id;
            const requestedAt = moment(item.createdAt).format(
              "DD MMM, YYYY - HH:mm a"
            );
            return (
              <TableRow
                key={index}
                row={{
                  name,
                  type,
                  todo,
                  bookingId,
                  description,
                  requestedAt,
                  status,
                }}
                tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-center first:text-left bg-[--bg-color-50] first:rounded-l-md last:rounded-r-md max-w-1/4 truncate"
              ></TableRow>
            );
          })
        ) : (
          <td
            colSpan={7}
            className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
          >
            There are no records to display
          </td>
        )}
      </Table>
      {!loader && oldRequestData?.data?.length > 0 && (
        <div className="flex justify-between items-center">
          <RowsPerPageSelector />
          <PageSelector
            rowPerPage={row_count}
            page={page}
            setpage={(newPage) => {
              setPage(newPage);
            }}
            totalDataCount={oldRequestData ? oldRequestData.totalCount : 0}
          />
        </div>
      )}
    </div>
  );
}

export default OldRequestTable;
